import React from 'react'

const ExternalLink = ({ url, children }: IProps) => (
  <a href={url} target="_blank" rel="noopener noreferrer">
    {children}
  </a>
)

interface IProps {
  url: string
  children: string
}

export default ExternalLink

const helpDocsUrl = 'https://vloggi.com/docs'

export const HelpDocsLink = ({ documentTag, children }: { documentTag: string; children: string }) => (
  <ExternalLink url={`${helpDocsUrl}/${documentTag}`}>
    {children}
  </ExternalLink>
)
